/**
 * Session gate around the LV shell: no valid session → LoginGate; valid
 * session → LvShell with that session. Subscribes to the session store, so
 * every transition routes through here — sign-out and a server-side 401 both
 * drop the session and land the learner back on the gate without a reload.
 *
 * `/` and surface routes come through main.tsx; the `/_diag` diagnostics page
 * stays ungated (CapCom's provisioning probes and operators read it before
 * auth exists).
 */
import { useEffect, useState } from 'react'
import LvShell from './LvShell'
import LoginGate from './LoginGate'
import { getSession, onSessionChange, type LvSession } from './auth'

export default function GatedShell({ initialSurfaceId }: { initialSurfaceId?: string }) {
  const [session, setSession] = useState<LvSession | null>(() => getSession())

  useEffect(() => onSessionChange(() => setSession(getSession())), [])

  if (!session) return <LoginGate />
  return <LvShell initialSurfaceId={initialSurfaceId} session={session} />
}
